export const getSelectStyles = (hasError = false) => ({
    control: (base, state) => ({
        ...base,
        borderColor: hasError ? '#ef4444' : state.isFocused ? '#2563eb' : '#d1d5db',
        boxShadow: state.isFocused ? '0 0 0 0.156vw rgba(37, 99, 235, 0.1)' : 'none', /* 3px */
        borderRadius: '0.417vw',   /* 8px */
        minHeight: '2.188vw',      /* 42px */
        fontSize: '0.729vw',       /* 14px */
        backgroundColor: state.isDisabled ? '#f1f5f9' : 'white',
        cursor: state.isDisabled ? 'not-allowed' : 'pointer',
        '&:hover': { borderColor: hasError ? '#ef4444' : '#2563eb' }
    }),
    option: (base, state) => ({
        ...base,
        fontSize: '0.729vw',       /* 14px */
        backgroundColor: state.isSelected ? '#2563eb' : state.isFocused ? '#eff6ff' : 'white',
        color: state.isSelected ? 'white' : '#1e293b',
        cursor: 'pointer',
        padding: '0.417vw 0.625vw' /* 8px 12px */
    }),
    placeholder: (base) => ({
        ...base,
        color: '#94a3b8',
        fontSize: '0.729vw'        /* 14px */
    }),
    singleValue: (base) => ({
        ...base,
        color: '#1e293b',
        fontSize: '0.729vw',       /* 14px */
    }),
    menu: (base) => ({
        ...base,
        borderRadius: '0.417vw',   /* 8px */
        boxShadow: '0 0.208vw 0.833vw rgba(0,0,0,0.12)', /* 4px 16px */
        // zIndex: 9999
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 99999
    }),
    menuList: (base) => ({
        ...base,
        maxHeight: '17.448vw',     /* 335px — ~10 options at ~28px each */
        borderRadius: '0.417vw',   /* 8px */
        paddingTop: 0,
        paddingBottom: 0
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (base, state) => ({
        ...base,
        padding: '0 0.521vw',      /* 0 10px */
        color: state.isDisabled ? '#cbd5e1' : '#64748b',
        cursor: state.isDisabled ? 'not-allowed' : 'pointer',
        '&:hover': { color: '#2563eb' }
    }),
    clearIndicator: (base) => ({
        ...base,
        padding: '0 0.208vw',      /* 0 4px */
        cursor: 'pointer',
        color: '#94a3b8',
        '&:hover': { color: '#64748b' },
        svg: {
            width: '0.729vw',      /* 14px */
            height: '0.729vw',     /* 14px */
        }
    }),
    valueContainer: (base) => ({
        ...base,
        padding: '0.104vw 0.417vw', /* 2px 8px */
    }),
    input: (base) => ({
        ...base,
        boxShadow: 'none',
        outline: 'none',
        margin: 0,
        padding: 0,
    }),
    noOptionsMessage: (base) => ({
        ...base,
        fontSize: '0.729vw', // your fixed size
    }),
});

const truncateLabel = (str, max = 50) =>
    str && str.length > max ? str.slice(0, max) + '…' : str;

export const formatOptionLabel = ({ label }) => (
    <div title={label} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {truncateLabel(label)}
    </div>
);